import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import type { FormProps } from 'antd';
import { eventBus } from '@/utils/eventBus';
import styles from './RefundsSupport.module.scss';
import icon1 from '@/assets/images/路径 5.png';
import { Form, Select, DatePicker, Button, Input } from 'antd';

const { Option } = Select;

const RefundsSupport: React.FC = () => {

  const dispatch = useAppDispatch();

  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);

  //是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);

  type FieldType = {
    refundType?: string;
    refundTimeType?: string;
    fromTime?: string;
    toTime?: string;
    advanceStatus?: string;
  };

  // 表单提交
  const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
    console.log('Success:', values);
  };

  // 表单提交失败
  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  //mounted 和unmounted
  useEffect(() => {
    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, []);

  //yourTownloopSearchValue关键字的监听
  useEffect(() => {
    console.log('RefundsSupport组件yourTownloopSearchValue', yourTownloopSearchValue);

  }, [yourTownloopSearchValue])

  return (
    <div className={styles['refunds-box']}>
      <div className={styles['refunds-title']}>Reviews From Sellers</div>
      <Form layout="inline"
        className={styles['refunds-form']}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item<FieldType>
          label="Refund Types:"
          name="refundType"
          rules={[{ required: true, message: 'Please input your Refund Types!' }]}
        >
          <Select style={{ width: isMobile ? '50vw' : 140 }}>
            <Option value="all">All</Option>
            <Option value="type1">Type 1</Option>
            <Option value="type2">Type 2</Option>
          </Select>
        </Form.Item>

        <Form.Item<FieldType>
          label="Refund Time:"
          name="refundTimeType"
          rules={[{ required: true, message: 'Please input your Refund Time!' }]}
        >
          <Select style={{ width: isMobile ? '50vw' : 140 }}>
            <Option value="recently">Recently</Option>
            <Option value="custom">Custom</Option>
          </Select>
        </Form.Item>
        <Form.Item<FieldType>
          label="From:"
          name="fromTime"
          rules={[{ required: true, message: 'Please input your from Time!' }]}
        >
          <DatePicker showTime style={{ width: isMobile ? '50vw' : 180 }} />
        </Form.Item>
        <Form.Item<FieldType>
          label="To:"
          name="toTime"
          rules={[{ required: true, message: 'Please input your to Time!' }]}
        >
          <DatePicker showTime style={{ width: isMobile ? '50vw' : 180 }} />
        </Form.Item>


        <Form.Item<FieldType>
          label="Advance Payment Status:"
          name="advanceStatus"
          rules={[{ required: true, message: 'Please input your Advance Payment Status!' }]}
        >
          <Select style={{ width: isMobile ? '50vw' : 120 }}>
            <Option value="all">All</Option>
            <Option value="paid">Paid</Option>
            <Option value="unpaid">Unpaid</Option>
          </Select>
        </Form.Item>
        <div className={styles['refunds-btn-group']}>
          {/* htmlType="submit"可以触发提交 */}
          <Button
            type="primary"
            className={styles['refunds-btn-submit']}
            htmlType="submit"
          >Submit</Button>
          <Button className={styles['refunds-btn-specifics']}>Specifics</Button>
        </div>
      </Form>
    </div>
  );
};

export default RefundsSupport; 